import { CreateFarmConfigDTO, CreateFarmDTO } from 'src/dto/farm.dto'
import { v4 as uuidv4 } from 'uuid'

export interface FarmParams {
  idFazenda?: string
  documento: string
  endereco?: string
  cidade?: string
  estado?: string
  proprietario: string
  descricao: string
  razao: string
  dataCriacao?: string
  configuracao?: CreateFarmConfigDTO
}

export class Farm implements CreateFarmDTO {
  idFazenda: string
  documento: string
  endereco: string
  cidade: string
  estado: string
  proprietario: string
  descricao: string
  razao: string
  dataCriacao: string
  configuracao?: CreateFarmConfigDTO

  constructor({
    idFazenda = uuidv4(),
    documento,
    endereco = '',
    cidade = '',
    estado = '',
    proprietario,
    descricao,
    razao,
    dataCriacao = new Date().toISOString(),
    configuracao = undefined
  }: FarmParams) {
    this.idFazenda = idFazenda
    this.documento = documento
    this.endereco = endereco
    this.cidade = cidade
    this.estado = estado
    this.proprietario = proprietario
    this.descricao = descricao
    this.razao = razao
    this.dataCriacao = dataCriacao
    this.configuracao = configuracao
  }
}
